import { SavedQueriesList, FilterLiveSearch } from 'react-admin';
import { Card, CardContent } from '@mui/material';

// @ts-ignore
const CloverMeteredFeeFilterSidebar = () => (
    <Card sx={{ order: -1, mr: 2, mt: 9, width: 200 }}>
        <CardContent>
            <SavedQueriesList />
            <FilterLiveSearch source="uuid" />
            <FilterLiveSearch source="metered_fee_uuid" />
            <FilterLiveSearch source="triggerable_type" />
            <FilterLiveSearch source="success" />
        </CardContent>
    </Card>
);

export default CloverMeteredFeeFilterSidebar; 